import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import logoImage from '../assets/image/cherma8.jpg';

export function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          <div className="footer__logo-wrapper">
            <div className="footer__logo-icon">
              <img src={logoImage} style={{ width: "40px" }} />
            </div>
            <h3 className="footer__logo-text">{t('temple.name')}</h3>
          </div>
          <p className="footer__tagline">
            {t('footer.tagline')}
          </p>
          <p className="footer__copyright">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}
